import ApplicantsList from "../../../components/ABOProfile/ApplicantComponents/ApplicantsList/ApplicantsList";
import { useGetProfileQuery } from "../../../services/Profile/profileAPI";
import { useAppSelector } from "../../../store";
import {
  cardActionClickTrack,
  profileApplicantCardErrorTrack,
} from "../../../common/tealium/CustomerProfile/Profile/ApplicantCardTrack";
import { ErrorTile } from "../../../common/components/ErrorTile/ErrorTile";

type Props = {
  isShowApplicant: boolean;
};

const CustomerApplicantBody = (props: Props) => {
  const { isShowApplicant } = props;

  const affAbo = useAppSelector((state) => state.profile.affAbo);
  const { selectedPeriod } = useAppSelector(({ period }) => period);

  const applicantTrackOnclick = (event?: string) => {
    cardActionClickTrack(event, false);
  };

  const { isFetching, isError, data, refetch } = useGetProfileQuery({ period: selectedPeriod, affAbo });

  if (isError === true) {
    profileApplicantCardErrorTrack();
  }

  const boot = useAppSelector(({ boot }) => boot);
  const profileInfo = boot?.configuration?.profile?.customerInfo || {};

  if (isShowApplicant && isFetching === false && data?.aboInfo && data.partyInfo) {
    const { aboInfo, partyInfo } = data;
    return (
      <ApplicantsList
        partyInfo={partyInfo}
        aboInfo={aboInfo}
        applicantTrackOnclick={applicantTrackOnclick}
        profileInfo={profileInfo}
      />
    );
  }

  return (
    <ErrorTile clickFunction={refetch} errorStatus={isError} isLoading={isFetching} tealiumTrackId="customer-table" />
  );
};

export default CustomerApplicantBody;
